/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListCaseResult } from '../models/ListCaseResult';
import type { ListTransitionReasonResult } from '../models/ListTransitionReasonResult';
import type { TransitionCaseCommand } from '../models/TransitionCaseCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminDeviceMarketplaceService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public transitionCase({
        requestBody,
    }: {
        requestBody: TransitionCaseCommand,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/device-marketplace/admin/cases/{caseId}',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ListTransitionReasonResult OK
     * @throws ApiError
     */
    public listReasons1({
        caseId,
    }: {
        caseId: string,
    }): CancelablePromise<ListTransitionReasonResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-marketplace/admin/reasons',
            query: {
                'caseId': caseId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ListCaseResult OK
     * @throws ApiError
     */
    public listAllCases({
        page,
        size,
        sortOrder,
        sortBy,
        entityId,
        imeiOrSerial,
        os,
        status,
        createdAfter,
        createdBefore,
    }: {
        page: number,
        size: number,
        sortOrder: string,
        sortBy: string,
        entityId?: string,
        imeiOrSerial?: string,
        os?: 'IOS' | 'ANDROID',
        status?: 'PENDING' | 'APPROVED' | 'ARCHIVED' | 'REJECTED' | 'CLOSED',
        createdAfter?: string,
        createdBefore?: string,
    }): CancelablePromise<ListCaseResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-marketplace/admin/cases',
            query: {
                'entityId': entityId,
                'imeiOrSerial': imeiOrSerial,
                'os': os,
                'status': status,
                'createdAfter': createdAfter,
                'createdBefore': createdBefore,
                'page': page,
                'size': size,
                'sortOrder': sortOrder,
                'sortBy': sortBy,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
